﻿import { IEwtSummary } from '../ewt-summary';
import { IEwtCounts } from '../ewt-counts';

export interface ITargetedChainEnd {
    adpStatus: string,
    adpType: string,
    adpSwapSaver: boolean,
    adpRtsf: boolean,
    recipientCenter: string,
    recipientId: number,
    recipientAlias: string,
    recipientBloodType: string,
    oTiterString: string,
    donorBloodType: string,
    transplantDate: string,
    maxDonorAge: number,
    minHLAMatch: number,
    cPRA4: number,
    recipientStatus: string,
    recipientStatusId: number,
    chainId: number,
    clCu: number,
    cprScore: number,
    cprScore2: number,
    rAge: number,
    dAge: number,
    rmPa: number,
    rmPb: number,
    rmPc: number,
    dmp: string,
    pmPa: number,
    pmPb: number,
    pmPc: number,
    erosion: number,
    dialysis: string,
    dialysisMonths: number,
    ewt: string,
    wtv: string,
    monthsSince: number,
    wait: number,
    exportableDaysInNkr: number,
    kWait: number,
    aWait: number,
    tWait: number,
    isActive: boolean,
    surgeryDate: string,
    acceptedDonors: number,
    onlyDonorIdMatchC: number,
    onlyDonorMatchCAlias: string,
    onlyDonorMatchCCenter: string,
    rexmStatus: string,
    aboCombo: string,
    sortOrder: number,
    ewtSummary: IEwtSummary,
    initialCount: IEwtCounts,
    highPra: boolean,
    pediatric: boolean,
    declineRatio: number,
    isMatchable: boolean
}
